import { Grid, Paper } from "@material-ui/core";
import { useStyles } from "features/admin/styles";
import { FIELDS, SubmitButton } from "components/Admin/InputFields/utils";
import { Field } from "features/admin/Products/types";
import React from "react";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import styled from "styled-components/macro";
import ProductsForProjectTable from "./ProductsForProjectTable";
import { HiddenInput } from "features/admin/Orders/actions/AddOrder";
import TextInputField from "components/Admin/InputFields/TextInputField";
import { MdSave } from "react-icons/md";
import { addProject } from "../adminGallerySlice";
import { setResponse } from "features/admin/adminSlice";
import { useNavigate } from "react-router";

interface AddGalleryItemProps {}

const AddGalleryItem: React.FC<AddGalleryItemProps> = ({}) => {
  const dispatch = useDispatch();
  const { setValue, handleSubmit, control, errors, getValues } = useForm();
  const navigate = useNavigate();
  const classes = useStyles();

  const onSubmit = (data: any) => {
    if (data.items.length === 0) {
      dispatch(
        setResponse({
          message: "Моля, добавете климатик към поръчката!",
          hasError: false,
        })
      );
      return;
    }
    dispatch(addProject(data));
    navigate(-1);
  };

  const renderField = (field: Field, idx: number) => {
    const Field = FIELDS[field.type];
    return <Field item={field} key={idx} control={control} reset={false} setValue={setValue} />;
  };

  return (
    <AddGalleryItemContainer>
      <Paper className={classes.paper}>
        <h1>Добави проект</h1>
        <p>
          Мета заглавие (дължина): 20 - 60 знака
          <br />
          Мета тагове (брой): 4 - 9 тага
          <br />
          Мета описание (дължина): 50 - 160 знака
        </p>
        <Grid container direction="row" wrap="wrap" align-items="center">
          <ProjectForm onSubmit={handleSubmit(onSubmit)} encType="multipart/form-data">
            {orderFields.map((item, idx) => {
              return renderField(item, idx);
            })}
            <HiddenInput>
              <TextInputField
                item={{
                  required: true,
                  type: "text",
                  title: "Добавени климатици",
                  name: "items",
                }}
                control={control}
                reset={false}
                setValue={setValue}
                errors={errors}
              />
            </HiddenInput>
            <ProductsForProjectTable setValue={setValue} getValues={getValues} />
            <StyledSubmitButton variant="contained" color="primary" type="submit" startIcon={<MdSave size="1.5rem" />}>
              Добави проект
            </StyledSubmitButton>
          </ProjectForm>
        </Grid>
      </Paper>
    </AddGalleryItemContainer>
  );
};

const AddGalleryItemContainer = styled.div`
  flex: 1;
`;

export const ProjectForm = styled.form`
  width: 100%;
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  align-items: center;

  .MuiFormControl-root {
    flex-basis: 100%;
  }
`;

export const StyledSubmitButton = styled(SubmitButton)`
  flex-basis: 100%;
`;

export default AddGalleryItem;

const orderFields: Field[] = [
  {
    required: true,
    type: "text",
    title: "Заглавие",
    name: "title",
    rules: {
      required: { value: true, message: "Полето е задължително" },
    },
  },
  {
    required: true,
    type: "text",
    title: "Описание",
    name: "description",
    rules: {
      required: { value: true, message: "Полето е задължително" },
    },
  },
  {
    name: "image_file",
    required: true,
    title: "Снимка",
    type: "file",
    rules: {
      required: { value: true, message: "Полето е задължително" },
    },
  },
  {
    required: false,
    type: "text",
    title: "Мета заглавие",
    name: "titleMeta",
  },
  {
    required: false,
    type: "text",
    title: "Мета тагове",
    name: "tagsMeta",
  },
  {
    required: false,
    type: "text",
    title: "Мета описание",
    name: "descriptionMeta",
  },
];
